"use client";

import { useMediaQuery } from "@mui/material";
import { NextUIProvider } from "@nextui-org/react";
import { SnackbarProvider } from "notistack";
import { useEffect } from "react";

export default function NextProvider({ children }) {
  const isDesktop = useMediaQuery("(min-width:1024px)");

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "F8") {
        console.log("Debugger activated");
        debugger; // This pauses execution if dev tools are open
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <NextUIProvider disableRipple>
      <SnackbarProvider
        anchorOrigin={{
          vertical: "top",
          horizontal: isDesktop ? "left" : "center",
        }}
        autoHideDuration={3000}
      />
      {children}
    </NextUIProvider>
  );
}
